"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpTooltip = void 0;
var react_1 = __importDefault(require("react"));
var react_tooltip_lite_1 = __importDefault(require("react-tooltip-lite"));
var styled_components_1 = __importStar(require("styled-components"));
var Icon_1 = require("./Icon");
var accessors_1 = require("../themes/accessors");
var TooltipContent = styled_components_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  max-width: 250px;\n  padding: ", "px;\n  font-family: ", ";\n"], ["\n  color: ", ";\n  max-width: 250px;\n  padding: ", "px;\n  font-family: ", ";\n"])), accessors_1.textColor('contrast'), accessors_1.space('md'), accessors_1.fontFamily('sansSerif'));
var HelpTooltip = function (props) {
    var text = props.text;
    var theme = styled_components_1.useTheme();
    var bgColor = accessors_1.color('main', 'base')({ theme: theme });
    return (react_1.default.createElement(react_tooltip_lite_1.default, { styles: { fill: accessors_1.textColor('contrast')({ theme: theme }) }, content: react_1.default.createElement(TooltipContent, null, text), tagName: "span", padding: 0, background: bgColor },
        react_1.default.createElement(Icon_1.Icon, { size: "sm", name: "help" })));
};
exports.HelpTooltip = HelpTooltip;
var templateObject_1;
